import { DatabaseRow } from "@Shape-Digital/kudzu-data/lib/types/common";
import { DashboardAppointmentAIReport } from "../AppointmentAIReportsTableContainer/getAppointmentAIReports";

const getReportDeliveryDeadlineHours = ({
  appointmentAIReport,
  systemConfig,
}: {
  appointmentAIReport: DashboardAppointmentAIReport;
  systemConfig: DatabaseRow<"system_configs">;
}): number => {
  const {
    appointment: { center, has_priority, is_stat },
  } = appointmentAIReport;

  const centerConfig = center.center_configs[0];

  if (is_stat) {
    return (
      centerConfig.stat_report_deadline_hours ||
      systemConfig.stat_report_deadline_hours ||
      0
    );
  }

  if (has_priority) {
    return (
      centerConfig.priority_report_deadline_hours ||
      systemConfig.priority_report_deadline_hours ||
      0
    );
  }

  return (
    centerConfig.report_delivery_deadline_hours ||
    systemConfig.report_delivery_deadline_hours ||
    0
  );
};

export default getReportDeliveryDeadlineHours;
